export const SET_SETTINGS_TRANSACTIONS = 'setSettingsTransactions';
export const SETTINGS_TRANSACTIONS = 'settingsTransactions';
export const TOAST_MESSAGES_PUSH = 'toastMessages/push';
